import { IconCaretLeft, IconCaretRight } from '@lmig/lmds-react-icons';
import { JSX, useCallback, useEffect, useState } from 'react';
interface IPagerProps {
  currentPage: number;
  count: number;
  maxShown: number;
  onChange: Function;
}
export default function Pager({ currentPage, count, maxShown, onChange }: IPagerProps) {
  let [pageComponent, setPageComponent] = useState<JSX.Element[]>([]);
  const clicked = useCallback(
    (value: string) => {
      if (value === 'prev') {
        if (currentPage > 1) {
          onChange(currentPage - 1);
        }
      } else if (value === 'next') {
        if (currentPage < count) {
          onChange(currentPage + 1);
        }
      } else {
        const newPage = parseInt(value);
        if (!isNaN(newPage)) onChange(newPage);
      }
    },
    [currentPage, count, onChange],
  );
  useEffect(() => {
    let pages = [];
    if (count !== undefined) {
      pages.push(currentPage);
      pages.push(1);
      pages.push(count);
      pages = Array.from(new Set(pages));
      let i = 1;
      while (pages.length <= maxShown) {
        if (currentPage + i < count && currentPage + i !== count) pages.push(currentPage + i);
        if (pages.length <= maxShown && currentPage - i > 0 && currentPage - i !== 1) pages.push(currentPage - i);
        i++;
        // i > 100 is a fail safe
        if ((currentPage + i >= count && currentPage - i <= 1) || i > 100) break;
      }
      pages = pages.filter((value) => {
        return value > 0 && value <= count;
      });
      pages = Array.from(new Set(pages));
      pages = pages.sort((a, b) => {
        return a - b;
      });
      setPageComponent(
        pages.map((page, index) => {
          const selected = page === currentPage;
          if (index === 1 && page !== 2) {
            return (
              <PagerItem key={'elipfirst'} value="elipfirst" selected={false} clickable={false}>
                ...
              </PagerItem>
            );
          } else if (index === maxShown - 1 && page !== count - 1) {
            return (
              <PagerItem key={'elipsecond'} value="elipsecond" selected={false} clickable={false}>
                ...
              </PagerItem>
            );
          } else {
            return (
              <PagerItem
                key={page.toString()}
                value={page.toString()}
                selected={selected}
                clickable={true}
                onClick={clicked}
              >
                {page}
              </PagerItem>
            );
          }
        }),
      );
    }
  }, [currentPage, count, maxShown, clicked]);
  return (
    <>
      {pageComponent.length > 0 && (
        <>
          <ul className="search-pager">
            <PagerItem value="prev" selected={false} clickable={currentPage !== 1} onClick={clicked}>
              <IconCaretLeft size="16" />
            </PagerItem>
            {pageComponent}
            <PagerItem value="next" selected={false} clickable={currentPage !== count} onClick={clicked}>
              <IconCaretRight size="16" />
            </PagerItem>
          </ul>
        </>
      )}
    </>
  );
}

interface IPagerItemProps {
  value: string;
  selected: boolean;
  clickable: boolean;
  onClick?: Function;
  children: any;
}
function PagerItem(props: IPagerItemProps) {
  let className = 'search-pager-element';
  className += props.clickable ? ' clickable' : '';
  className += props.selected ? ' page-selected' : '';
  if (props.clickable && props.onClick)
    return (
      <li
        className={className}
        onClick={() => props.onClick && props.onClick(props.value)}
        aria-label={props.value}
        role="option"
        aria-selected={props.selected}
      >
        {props.children}
      </li>
    );
  else
    return (
      <li className={className} aria-label={props.value} role="option" aria-selected={false}>
        {props.children}
      </li>
    );
}
